export default "__VITE_ASSET__4ba0db53__"